import { render, staticRenderFns } from "./LiveNew.vue?vue&type=template&id=233846b6&scoped=true&"
import script from "./LiveNew.vue?vue&type=script&lang=js&"
export * from "./LiveNew.vue?vue&type=script&lang=js&"
import style0 from "./LiveNew.vue?vue&type=style&index=0&id=233846b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "233846b6",
  null
  
)

export default component.exports